import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { updateAccountApprovalsPreference } from 'services/ApprovalsService'

export const useAccountApprovalsPreferenceMutation = () => {
  return useMutation(updateAccountApprovalsPreference, {
    onError: (error: unknown) => {
      logSentryError(
        'Error from useAccountApprovalsPreferenceMutation - updateAccountApprovalsPreference',
        error
      )
    },
  })
}
